/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const DOWNLOAD_PATH =
  'M6.2175 9.9675C6.1472 10.0372 6.09141 10.1202 6.05333 10.2116C6.01526 10.303 5.99565 10.401 5.99565 10.5C5.99565 10.599 6.01526 10.697 6.05333 10.7884C6.09141 10.8798 6.1472 10.9628 6.2175 11.0325L8.4675 13.2825C8.53722 13.3528 8.62017 13.4086 8.71157 13.4467C8.80296 13.4847 8.90099 13.5043 9 13.5043C9.09901 13.5043 9.19704 13.4847 9.28843 13.4467C9.37983 13.4086 9.46278 13.3528 9.5325 13.2825L11.7825 11.0325C11.9237 10.8913 12.0031 10.6997 12.0031 10.5C12.0031 10.3003 11.9237 10.1087 11.7825 9.9675C11.6413 9.82627 11.4497 9.74693 11.25 9.74693C11.0503 9.74693 10.8587 9.82627 10.7175 9.9675L9.75 10.9425V2.25C9.75 2.05109 9.67098 1.86032 9.53033 1.71967C9.38968 1.57902 9.19891 1.5 9 1.5C8.80109 1.5 8.61032 1.57902 8.46967 1.71967C8.32902 1.86032 8.25 2.05109 8.25 2.25V10.9425L7.2825 9.9675C7.21278 9.8972 7.12983 9.84141 7.03843 9.80333C6.94704 9.76525 6.84901 9.74565 6.75 9.74565C6.65099 9.74565 6.55296 9.76525 6.46157 9.80333C6.37017 9.84141 6.28722 9.8972 6.2175 9.9675ZM13.5 6.75H12C11.8011 6.75 11.6103 6.82902 11.4697 6.96967C11.329 7.11032 11.25 7.30109 11.25 7.5C11.25 7.69891 11.329 7.88968 11.4697 8.03033C11.6103 8.17098 11.8011 8.25 12 8.25H13.5C13.6989 8.25 13.8897 8.32902 14.0303 8.46967C14.171 8.61032 14.25 8.80109 14.25 9V14.25C14.25 14.4489 14.171 14.6397 14.0303 14.7803C13.8897 14.921 13.6989 15 13.5 15H4.5C4.30109 15 4.11032 14.921 3.96967 14.7803C3.82902 14.6397 3.75 14.4489 3.75 14.25V9C3.75 8.80109 3.82902 8.61032 3.96967 8.46967C4.11032 8.32902 4.30109 8.25 4.5 8.25H6C6.19891 8.25 6.38968 8.17098 6.53033 8.03033C6.67098 7.88968 6.75 7.69891 6.75 7.5C6.75 7.30109 6.67098 7.11032 6.53033 6.96967C6.38968 6.82902 6.19891 6.75 6 6.75H4.5C3.90326 6.75 3.33097 6.98705 2.90901 7.40901C2.48705 7.83097 2.25 8.40326 2.25 9V14.25C2.25 14.8467 2.48705 15.419 2.90901 15.841C3.33097 16.2629 3.90326 16.5 4.5 16.5H13.5C14.0967 16.5 14.669 16.2629 15.091 15.841C15.5129 15.419 15.75 14.8467 15.75 14.25V9C15.75 8.40326 15.5129 7.83097 15.091 7.40901C14.669 6.98705 14.0967 6.75 13.5 6.75Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Download glyph (18×18). Color via `fill` default `currentColor` (inherits CSS `color` / `--ds-icon-default-color`).
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const DownloadIcon = ({
  size = 18,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={DOWNLOAD_PATH} fill={fill} />
  </svg>
);

DownloadIcon.propTypes = {
  ...iconPropTypes,
  /** Any valid SVG fill; default inherits text/icon color. */
  fill: PropTypes.string,
};

export { DownloadIcon };
export default DownloadIcon;
